import { Injectable } from "@angular/core";
import { GlobalConstants } from "src/app/constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  UserDefinedCodesAdapter,
  UserDefinedCodes
} from "../Model/user-defined-codes";
import { map } from "rxjs/operators";
import * as moment from "moment";

@Injectable({
  providedIn: "root"
})
export class UdcServiceService {
  private baseURL =
    GlobalConstants.BASE_API_URL + ":" + GlobalConstants.BASE_API_URL_PORT;
  private API_NAME = "SYTypeMaster";

  constructor(
    private httpClient: HttpClient,
    private adapter: UserDefinedCodesAdapter
  ) {}

  getAll(): Observable<UserDefinedCodes[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/all`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
    );
  }

  getKeyValues(key1, key2): Observable<UserDefinedCodes[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/keyValues`;
    const params = new HttpParams().set("key1", key1).set("key2", key2);
    return this.httpClient.get(url, { params }).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
    );
  }

  checkForDuplicate(
    key1,
    key2,
    parentValue,
    id
  ): Observable<UserDefinedCodes[]> {
    // If id is <> null, then it is an update and need to make sure
    // not checking for a duplicate on it's on record ID, else
    // check without ID on a create
    if (id != null) {
      const url = `${this.baseURL}/${this.API_NAME}/api/check/duplicate`;
      const params = new HttpParams()
        .set("key1", key1)
        .set("key2", key2)
        .set("parentValue", parentValue)
        .set("id", id);
      return this.httpClient.get(url, { params }).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
      );
    } else {
      // Creation duplicate check, since no ID.  No need to check by ID
      const url = `${this.baseURL}/${
        this.API_NAME
      }/api/get/bykey1key2Andparent`;
      const params = new HttpParams()
        .set("key1", key1)
        .set("key2", key2)
        .set("parentValue", parentValue);
      return this.httpClient.get(url, { params }).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
      );
    }
  }

  update(formData, id) {
    // Format lastUpdated to IBM i standards
    formData.lastUpdated = moment().format("YYYY-MM-DD-HH.mm.ss");

    // Add database ID to the JSON object for update service
    formData.id = id;
    formData.changeID = localStorage.getItem("user");
    const url = `${this.baseURL}/${this.API_NAME}/api/update`;
    return this.httpClient.post(url, formData);
  }

  delete(id) {
    const url = `${this.baseURL}/${this.API_NAME}/api/delete`;
    return this.httpClient.post(url, { id: id });
  }

  create(formData) {
    formData.changeID = localStorage.getItem("user");

    const url = `${this.baseURL}/${this.API_NAME}/api/create`;
    return this.httpClient.post(url, formData);
  }
}
